// extracted by mini-css-extract-plugin
module.exports = {"selection-panel":"style_selection-panel__3MuwS","panel-buttons":"style_panel-buttons__2k85I"};